var cellphone9DigitOptions = {
    onKeyPress: function (phone, e) {
        $target = $(e.target);
        if (/(\((1|2|3|4|5|6|7|8|9)\d\) 9?(9|8|7)).+/i.test(phone)) {
            $($target).mask('(00) 00000.0000', cellphone9DigitOptions);
        } else {
            $($target).mask('(00) 0000.0000', cellphone9DigitOptions);
        }
    }
};